module.exports = __webpack_public_path__ + "static/media/digren.95d6af4f.png";